import {
  buildAdebifyFilterKeySet,
  DEFAULT_ADEBIFY_AXIS,
  PRODUCT_FILTERS,
  MEDIA_FILTERS,
  ADEBIS_FILTERS,
} from 'domain/adebify/screenFilterKeys';

// Filter visibility rules for the 商品分析 (Adebify Product Analysis) screen.
//
// Source of truth: adebify/docs/要件.md §456-468 (付録E-1) and §282-291
// (要件 14-2 traffic-mode rule).
const getAdebifyProductAnalysisFilterKeys = (
  currentTab,
  filterContext = {}
) => {
  const axis =
    filterContext.adebifyProductAnalysisAxis ||
    filterContext.axis ||
    DEFAULT_ADEBIFY_AXIS;

  return buildAdebifyFilterKeySet({ axis, currentTab });
};

export { PRODUCT_FILTERS, MEDIA_FILTERS, ADEBIS_FILTERS };
export default getAdebifyProductAnalysisFilterKeys;
